import React, { useEffect } from "react";
import CaseHero from "../commonCase/CaseHero";
import icon from "../../../../assets/svgs/aessvg.svg";
import Task from "../commonCase/Task";
import Task1 from "../commonCase/Task1";
import website from "../../../../assets/images/aesimg.webp";
import Design from "../commonCase/Design";
import work1 from "../../../../assets/images/aeswork1.webp";
import work2 from "../../../../assets/images/aeswork2.webp";
import Work from "../commonCase/Work";
import result1 from "../../../../assets/svgs/softsidecard1.svg";
import result2 from "../../../../assets/svgs/softsidecard2.svg";
import result3 from "../../../../assets/svgs/softsidecard3.svg";
import Result from "../commonCase/Result";
import linkdin from "../../../../assets/svgs/linkdin 2.svg";
import Data from "../../Data";
import tanks from "../../../../assets/svgs/tankssvg.svg";
import softside from "../../../../assets/svgs/softsidesvg.svg";
import OtherProject from "../commonCase/OtherProject";
import ggp from "../../../../assets/svgs/ggpsvg.svg";

const tableData = [
  { task: "Website Design & Dev", status: true },
  { task: "Branding", status: true },
];

const task1Data = [
  {
    subheading: "User Experience Review: ",
    des: "Identified friction points in navigation and improved how candidates and clients explore job listings and service offerings.",
  },
  {
    subheading: "Site Performance Check: ",
    des: "Improved load times and responsiveness, especially on internal pages, to ensure smooth access for returning clients and job seekers.",
  },
  {
    subheading: "Mobile Optimization: ",
    des: "Made the website mobile-first, knowing that many candidates browse opportunities and submit interest via phone.",
  },
  {
    subheading: "Service Page Revamp: ",
    des: "Reworked page layouts for different service verticals to showcase expertise clearly and encourage meaningful conversions.",
  },
  {
    subheading: "Contact Flow Simplification: ",
    des: "Simplified the contact and inquiry process so decision-makers and talent could reach AES without unnecessary steps or confusion.",
  },
];

const task2Data = [
  {
    subheading: "Linkdin Banner: ",
    des: "Designed a professional cover banner that instantly reflects AES’s authority and positioning in the executive recruitment space.",
  },
  {
    subheading: "Business Card: ",
    des: "Crafted a minimal & premium business card for its Director that leaves a lasting impression during every client meeting.",
  },
];

const images = [work1, work2];

const cardData = [
  {
    icon: result1,
    subheading: "Clearer Brand Positioning",
    text: "The new website and brand assets gave AES a refined identity that instantly builds trust and communicates its specialization in executive search within the engineering sector.",
  },
  {
    icon: result2,
    subheading: "Improved Lead Confidence",
    text: "With professional design and smoother navigation, potential clients and candidates felt more confident engaging with AES through the website and digital touchpoints.",
  },
  {
    icon: result3,
    subheading: "Polished First Impressions",
    text: "Updated LinkedIn banners and business cards ensured AES’s team made a lasting first impression across networking platforms and digital outreach efforts.",
  },
];

const linkData = [
  {
    logo: linkdin,
    link: "https://www.linkedin.com/company/civilengineringrecruitment",
    linkName: "Linkdin.AesRecuriment",
  },
];
const project = [
  {
    name: "SoftSide",
    img: softside,
    link: "/case-study/softside",
  },
  {
    name: "TanskandCovers",
    img: tanks,
    link: "/case-study/tanksandcover",
  },
  {
    name: "Global Growth Partners",
    img: ggp,
    link: "/case-study/ggp",
  },
];

const Aes = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "AES Digital Marketing Case Study | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Explore how TechQilla helped AES improve leads, visibility, and performance through targeted digital marketing strategies.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "Digital Marketing Case Study");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute("href", " https://www.techqilla.com/case-study/aes");
  }, []);

  return (
    <div className="pt-[100px] lg:pt-[80px]">
      <CaseHero
        name="Aes Recuritment"
        highlited="Aes Recuriment"
        title="Case Study for"
        icon={icon}
        subtitle="Website Design and Development, Branding "
        date={2024}
      />
      <Task
        rows={tableData}
        bgColor="bg-[#231E54]" // Custom background color
        headerColor="bg-[#2E388F]" // Custom header color
        className=""
        text1="Alexander Executive Search (AES), a premier recruitment agency specializing in civil engineering and related sectors, recognized the need to modernize its digital presence. The existing website lacked the sophistication and user experience expected by their target audience, leading to diminished engagement and brand perception."
      />
      <Task1
        heading="Website Design & Development"
        text="We built the AES website from the ground up and here’s how we did it."
        list={task1Data}
        listcolor="text-[#2E388F]"
        listStyleColor="fill-[#2E388F]"
      />
      <Design
        heading="Website design"
        bgcolor="bg-[#231E54]"
        img={website}
        link="https://www.aesrecruitment.com"
        linkName="www.aesrecruitment.com"
      />
      <Task1
        heading="Branding"
        text="We created sleek brand assets to help AES present a polished image across networking channels."
        list={task2Data}
        listcolor="text-[#2E388F]"
        listStyleColor="fill-[#2E388F]"
      />
      <Work
        bgColor="bg-[#2E388F]"
        heading="Business Card & Linkedin Banner"
        img={images}
        link={linkData}
        grid="lg:grid-cols-2"
      />
      <Result
        cardColor="bg-[#231E54]"
        heading="Results"
        text="Here’s what changed after we stepped in"
        cards={cardData}
      />
      <OtherProject project={project} />
      <Data />
    </div>
  );
};

export default Aes;
